
export class IFilterOfferLimit{
    department?: number = 0
    city?: number = 0;
    name?: string = "";
    company?: string | null = null;
    limit: number = 0;
    offset: number = 0;
    state: Array<string> = [];
}